import { useState } from 'react'
import useIsomorphicLayoutEffect from 'hooks/useIsomorphicLayoutEffect'
import { CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH } from './cartPanelConstants'

function useCartPanelDesktopTileLayout(rootRef: React.RefObject<HTMLDivElement | null>) {
  const [isDesktopLayout, setIsDesktopLayout] = useState(false)

  useIsomorphicLayoutEffect(() => {
    const node = rootRef.current
    if (!node) return

    const updateLayout = () => {
      setIsDesktopLayout(node.getBoundingClientRect().width >= CART_PANEL_DESKTOP_LAYOUT_MIN_WIDTH)
    }

    updateLayout()

    const observer = new ResizeObserver(() => {
      updateLayout()
    })
    observer.observe(node)

    return () => {
      observer.disconnect()
    }
  }, [rootRef])

  return isDesktopLayout
}

export default useCartPanelDesktopTileLayout
